import { type DependencyList, useEffect, useRef } from 'react'
import { doNothing } from 'remeda'
import { handleError } from '@velasca/utils/handle-error'

/**
 * Ensures a video element autoplays correctly in Chrome by setting the `muted`
 * DOM property imperatively. React does not reliably reflect the `muted` prop
 * as an HTML attribute, which can prevent autoplay.
 */
export const ensureMutedAutoplay = (
  video: HTMLVideoElement,
  onError: (error: unknown) => void = doNothing,
): void => {
  video.defaultMuted = true
  video.muted = true
  video.play().catch(onError)
}

export const useAutoplayVideo = (
  deps: DependencyList = [],
): React.RefObject<HTMLVideoElement> => {
  const ref = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = ref.current

    if (!video) {
      return
    }

    ensureMutedAutoplay(video, handleError)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return ref
}
